import * as React from "react";
import { IOffer } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { Button } from "@nju/ui";
import { PackageDescription, PackagePrice } from "../../shared";
import { IButtonType, IPackageType } from "../types";

interface ISelectOfferVariantProps {
  isFirst: boolean;
  isLast: boolean;
  isVoicePackage: boolean;
  isDataPackage: boolean;
  selectedOffer: IOffer;
  offers: IOffer[];
  packageType: IPackageType;
  onSelect: (type: IButtonType, packageType: IPackageType) => void;
  testId?: string;
}

export function Package({
  selectedOffer,
  isVoicePackage,
  isDataPackage,
  isFirst,
  isLast,
  onSelect,
  offers,
  packageType,
  testId,
}: ISelectOfferVariantProps) {
  const isPrevButtonDisabled = offers.length === 1 || isFirst;
  const isNextButtonDisabled = offers.length === 1 || isLast;

  const handlePressNext = React.useCallback(() => {
    onSelect("NEXT", packageType);
  }, [onSelect, packageType]);

  const handlePressPrevious = React.useCallback(() => {
    onSelect("PREVIOUS", packageType);
  }, [onSelect, packageType]);

  return (
    <div className="block max-w-[500px] px-6 py-4 border-2 rounded-button border-geyser">
      <div
        className="flex justify-between items-center"
        data-cy={testId?.concat("-panel")}
      >
        <Button
          data-cy={testId?.concat("-minus-button")}
          display="inline"
          isDisabled={isPrevButtonDisabled}
          onPress={handlePressPrevious}
          size="inline"
          variant="simple"
        >
          <div className="flex justify-center items-center bg-cerulean rounded-full w-[40px] h-[40px] hover:opacity-80">
            <Icon height={16} name="minus" tone="secondary" width={16} />
          </div>
        </Button>
        <div className="flex flex-col items-center max-w-[230px]">
          <PackageDescription
            align="center"
            grantValue={selectedOffer?.balances?.[0]?.grantValue}
            isDataPackage={isDataPackage}
            isUnlimitedVoicePackage={
              selectedOffer?.balances?.[0].balanceId === "21202"
            }
            isVoicePackage={isVoicePackage}
          />
          <PackagePrice
            align="center"
            amount={selectedOffer.productOfferingPrice?.price.amount}
            refillPeriod={selectedOffer.refillPeriod}
          />
        </div>
        <Button
          data-cy={testId?.concat("-plus-button")}
          display="inline"
          isDisabled={isNextButtonDisabled}
          onPress={handlePressNext}
          size="inline"
          variant="simple"
        >
          <div className="flex justify-center items-center bg-cerulean rounded-full w-[40px] h-[40px] hover:opacity-80">
            <Icon height={16} name="plus" tone="secondary" width={16} />
          </div>
        </Button>
      </div>
    </div>
  );
}
